<template>
  <!-- Login Component -->
  <div>
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large>mdi-logout</v-icon>
        <h1 class="page-title">Logout</h1>
      </v-layout>
    </div>

    <v-form>
      <v-content>
        <v-row>
          <v-col cols="12">Are you sure you want to logout?</v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col col="12"><v-btn outlined @click="logout">Logout</v-btn></v-col>
        </v-row>
      </v-content>
    </v-form>
  </div>
</template>

<script>
import store from '@/store/index.js'
import router from '@/router/index.js'

export default {
  name: 'logout',
  components: {},
  router: router,
  store: store,
  data: () => ({
    showPassword: false
  }),
  methods: {
    logout() {
      store.commit('logoutUser')
      router.push('/login')
    }
  }
}
</script>
